import { all, takeLatest } from "redux-saga/effects";
import {
  GET_ACCESS_TOKEN,
  GET_USER_DETAILS,
  SEND_USER_REQUEST,
  UPDATE_ACCESS,
  DELETE_ACCESS,
} from "../modules/auth";
import {
  GET_UNITS_DATA,
  GET_FILTER_OPTIONS,
  GET_DEFAULT_FILTERS,
  GET_CIC_AND_UPC_DETAILS,
} from "../modules/dashboard";
import {
  GET_DC_STORE_DATA,
  GET_STORE_ORDER_DATA,
  GET_BUYER_COMMENTS_DATA,
  GET_DC_STORE_TOTAL,
  GET_STORE_ORDER_TOTAL,
} from "../modules/orderHistory";
import {
  GET_ORDER_HISTORY_DSD_DATA,
  GET_ORDER_HISTORY_DSD_TOTAL_QUANTITY,
} from "../modules/dsdOrderHistory";
import { GET_DC_RESEARCH_DATA } from "../modules/dcResearch";
import { GET_RETAIL_ADJUSTMENTS_DATA } from "../modules/retailAdjustments";
import { GET_INVOICE_RECEIPTS_RESEARCH_DATA } from "../modules/invoiceReceipts";
import {
  GET_MONTHLY_USAGE_COUNT,
  GET_UNIQUE_SCAN_USER_COUNT,
  GET_UNIQUE_USER_COUNT,
  GET_USAGE_DETAILS,
  MONITOR_BARCODE_USAGE,
  MONITOR_VIEW_REPORT,
} from "../modules/monitor";
import {
  getAccessTokenSaga,
  getUserDetailsSaga,
  sendUserRequestSaga,
  updateUserAccessSaga,
  deleteUserAccessSaga,
} from "./auth";
import {
  getWarehouseKPIDataSaga,
  getStoreKPIDataSaga,
  getFilterOptionsSaga,
  getDefaultFiltersSaga,
  getCICDetailsSaga,
} from "./dashboard";
import {
  getDcStoreDataSaga,
  getStoreOrderDataSaga,
  getBuyerCommentsDataSaga,
  getDcStoreTotalSaga,
  getStoreOrderTotalSaga,
} from "./orderHistory";
import {
  getOrderHistoryDsdDataSaga,
  getOrderHistoryDsdTotalQuantitySaga,
} from "./dsdOrderHistory";
import { getDcResearchDataSaga } from "./dcResearch";
import { getRetailAdjustmentsDataSaga } from "./retailAdjustments";
import { getInvoiceReceiptsResearchDataSaga } from "./invoiceReceipts";
import {
  getMonthlyUsageCountSaga,
  getUniqueUserCountSaga,
  getUsageDetailsSaga,
  monitorViewReportSaga,
  monitorBarcodeUsageSaga,
  getUniqueScanUserCountSaga,
} from "./monitor";

export function* rootSaga() {
  yield all([takeLatest(GET_ACCESS_TOKEN, getAccessTokenSaga)]);
  yield all([takeLatest(GET_USER_DETAILS, getUserDetailsSaga)]);
  yield all([takeLatest(SEND_USER_REQUEST, sendUserRequestSaga)]);
  yield all([takeLatest(UPDATE_ACCESS, updateUserAccessSaga)]);
  yield all([takeLatest(DELETE_ACCESS, deleteUserAccessSaga)]);
  yield all([takeLatest(GET_FILTER_OPTIONS, getFilterOptionsSaga)]);
  yield all([takeLatest(GET_DEFAULT_FILTERS, getDefaultFiltersSaga)]);
  yield all([takeLatest(GET_CIC_AND_UPC_DETAILS, getCICDetailsSaga)]);
  yield all([takeLatest(GET_UNITS_DATA, getWarehouseKPIDataSaga)]);
  yield all([takeLatest(GET_UNITS_DATA, getStoreKPIDataSaga)]);
  yield all([takeLatest(GET_DC_STORE_DATA, getDcStoreDataSaga)]);
  yield all([takeLatest(GET_STORE_ORDER_DATA, getStoreOrderDataSaga)]);
  yield all([takeLatest(GET_DC_STORE_TOTAL, getDcStoreTotalSaga)]);
  yield all([takeLatest(GET_STORE_ORDER_TOTAL, getStoreOrderTotalSaga)]);
  yield all([
    takeLatest(GET_ORDER_HISTORY_DSD_DATA, getOrderHistoryDsdDataSaga),
  ]);
  yield all([
    takeLatest(
      GET_ORDER_HISTORY_DSD_TOTAL_QUANTITY,
      getOrderHistoryDsdTotalQuantitySaga,
    ),
  ]);
  yield all([takeLatest(GET_BUYER_COMMENTS_DATA, getBuyerCommentsDataSaga)]);
  yield all([takeLatest(GET_DC_RESEARCH_DATA, getDcResearchDataSaga)]);
  yield all([
    takeLatest(GET_RETAIL_ADJUSTMENTS_DATA, getRetailAdjustmentsDataSaga),
  ]);
  yield all([
    takeLatest(
      GET_INVOICE_RECEIPTS_RESEARCH_DATA,
      getInvoiceReceiptsResearchDataSaga,
    ),
  ]);
  yield all([takeLatest(GET_USAGE_DETAILS, getUsageDetailsSaga)]);
  yield all([takeLatest(GET_MONTHLY_USAGE_COUNT, getMonthlyUsageCountSaga)]);
  yield all([takeLatest(GET_UNIQUE_USER_COUNT, getUniqueUserCountSaga)]);
  yield all([
    takeLatest(GET_UNIQUE_SCAN_USER_COUNT, getUniqueScanUserCountSaga),
  ]);
  yield all([takeLatest(MONITOR_VIEW_REPORT, monitorViewReportSaga)]);
  yield all([takeLatest(MONITOR_BARCODE_USAGE, monitorBarcodeUsageSaga)]);
}
